export default {
  Eyebrow: 'Define a reusable plan',
  Title: 'Add playbook details',
  EditTitle: 'Edit Playbook details',
  Cancel: 'Cancel',
  Create: 'Create playbook',
  NextStep: 'Next step',
  SaveChanges: 'Save changes',
  TitleLabel: 'Playbook name',
  TitlePlaceholder: 'Enter playbook title',
  DescriptionLabel: 'Description',
  DescriptionPlaceholder: 'Feel free to include specific details',
  GroupLabel: 'Group',
  NewGroupPlaceholder: 'Enter group name',
  GroupMode: {
    Existing: 'Existing group',
    New: 'New group',
  },
  Tabs: {
    Basic: 'Basic',
    Steps: 'Steps',
    Engagement: 'Engagement',
  },
  StepEditor: {
    Placeholder: 'e.g. Send welcome email on day 1 @sarah',
    Footer: 'Mention a day to group automatically. Optionally, use @name to assign, /skill to link a skill.',
    AddDescriptionTemplate: 'Add description template',
    EditDescriptionTemplate: 'Edit description template',
    HideDescriptionTemplate: 'Hide description template',
    DescriptionTemplateLabel: 'Task description template',
    DescriptionTemplateFooter: 'Supports Markdown formatting, checklists, and instructions for the generated task.',
    Loading: 'Loading...',
    NoMatches: 'No matches found.',
    AssignedTo: 'Assigned to #{name}',
    Day: 'Due on day #{day}',
  },
  RuleEditor: {
    Placeholder: 'e.g. if client responds positively to x, create a task for next step. If they respond negatively, create a task to re-do y.',
    Loading: 'Loading...',
    NoMatches: 'No matches found.',
    AssignedTo: 'Assigned to #{name}',
    Title: 'Add an engagement rule',
  },
  StepPreview: {
    Day: 'Day #{day}',
    Unassigned: 'Unassigned',
    Unassign: 'Unassign',
    DoneDescriptionTemplate: 'Done',
  },
};
